import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { BannerOut, BannersResponse } from "../types";
import { openExternalLink } from "../lib/telegram";

const ROTATE_INTERVAL_MS = 4000;
const BANNER_ASPECT_RATIO = 3.8;

export function BannerCarousel() {
  const [banners, setBanners] = useState<BannerOut[] | null>(null);
  const [index, setIndex] = useState(0);
  const [failedSlots, setFailedSlots] = useState<Set<number>>(new Set());
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    api
      .get<BannersResponse>("/api/banners")
      .then((res) => setBanners(res.banners))
      .catch(() => setBanners([]));
  }, []);

  const visibleBanners = (banners ?? []).filter((b) => !failedSlots.has(b.slot));

  useEffect(() => {
    if (visibleBanners.length <= 1) return;
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % visibleBanners.length);
    }, ROTATE_INTERVAL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [visibleBanners.length]);

  if (visibleBanners.length === 0) return null;
  const clampedIndex = index % visibleBanners.length;

  return (
    <div className="relative w-full rounded-2xl overflow-hidden glass-card shrink-0" style={{ aspectRatio: BANNER_ASPECT_RATIO }}>
      {visibleBanners.map((banner, i) => (
        <button
          key={banner.slot}
          type="button"
          onClick={() => openExternalLink(banner.link)}
          className="absolute inset-0 transition-opacity duration-500"
          style={{ opacity: i === clampedIndex ? 1 : 0, pointerEvents: i === clampedIndex ? "auto" : "none" }}
          aria-label={`إعلان ${i + 1}`}
        >
          <img
            src={banner.image_url}
            alt=""
            className="w-full h-full object-cover"
            draggable={false}
            onError={() =>
              setFailedSlots((prev) => {
                const next = new Set(prev);
                next.add(banner.slot);
                return next;
              })
            }
          />
        </button>
      ))}

      {visibleBanners.length > 1 && (
        <div className="absolute bottom-1.5 left-1/2 -translate-x-1/2 flex gap-1.5">
          {visibleBanners.map((banner, i) => (
            <span
              key={banner.slot}
              className={`h-1.5 rounded-full transition-all ${
                i === clampedIndex ? "w-4 bg-white" : "w-1.5 bg-white/40"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
